import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import Icon from '../Icon';

// technically all we really need is to set the props to 
// "React.ComponentPropsWithoutRef<typeof Svg>", but in order for our custom
// props to come through in Storybook we need to bring them up again here 

export default function ResizeIcon(_ref) {
  let {
    contextType = 'image',
    className = '',
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(Icon, _extends({
    viewBox: "0 0 40 40"
  }, props, {
    contextType: contextType,
    className: `pi pi-resize-icon ${className}`
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M17.97 40c.32-.15.66-.25.94-.44.71-.49 1.08-1.18 1.09-2.05.01-1.41 0-2.81 0-4.22v-.78h2.48v-2.49H20v-1.59c0-1.55 0-3.1.01-4.65 0-.14.05-.32.14-.41 2.4-2.41 4.8-4.81 7.2-7.21.02-.02.06-.04.15-.08v1.85c0 1.51-.01 3.02 0 4.53.02 1.51 1.12 2.57 2.62 2.54 1.34-.03 2.38-1.19 2.38-2.63-.01-4.06-.01-8.12 0-12.18 0-1.61-1.08-2.69-2.68-2.69-4.06.01-8.12.01-12.18 0-1.46 0-2.62 1.05-2.64 2.41-.02 1.49 1.04 2.57 2.57 2.59 1.95.02 3.9 0 5.86 0h.51c-.11.13-.17.21-.24.29-2.34 2.34-4.67 4.68-7.01 7.01a.7.7 0 01-.39.2h-6.18c-.02 0-.05-.01-.12-.03v-2.45H7.51V20H2.75c-1.46 0-2.23.56-2.7 1.94 0 .03-.03.06-.05.09v15.94c.16.34.29.69.49 1 .36.57.94.82 1.55 1.03h15.93zM40 25h-2.49v4.99h-4.98v2.51h4.79c1.35 0 2.19-.61 2.61-1.9.02-.05.05-.09.07-.13V25zM9.53 0c-.52.2-1.04.4-1.41.85-.4.48-.62 1.02-.62 1.64v4.98h2.49V2.5h5V-.01C13.18 0 11.35 0 9.53 0zM32.5 0v2.5h4.99v5H40V2.03c-.16-.33-.29-.69-.49-1-.35-.56-.94-.82-1.54-1.03H32.5zM40 17.5h-2.48v5H40v-5zM40 10h-2.48v5H40v-5zM17.5 0v2.48h5V0h-5zM25 0v2.48h5V0h-5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.98 30.02h-4.96v2.45h4.96v-2.45zM7.52 14.98h2.46v-4.95H7.52v4.95z"
  })));
}